module.exports = __webpack_public_path__ + "media/OVI_OABH2_2_Stufe02.60974b73.mp3";